"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgFlight(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#4D4D4D"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.291 8.338L5.076 9.696s-.588.458-1.697.23c-1.109-.23-2.246-.48-2.246-.48s-.244-.09-.412.129c-.168.217.108.347.108.347l1.71 1.239s.366.361.903.266c.537-.095 2.117-.415 2.117-.415s1.078-.23 2.36-1.03c1.282-.8 5.866-3.582 5.866-3.582s1.784-1.013 1.605-1.438c-.179-.424-1.207-.31-1.7-.155-.49.155-4.329 2.33-4.329 2.33L5.155 5.695s-.544-.129-.272.189c.272.317 2.937 2.97 2.937 2.97m1.043 1.509l1.143 1.14s.331.262.398-.653.135-1.6.135-1.6"
  }));
}

var MemoSvgFlight = /*#__PURE__*/React.memo(SvgFlight);
var _default = MemoSvgFlight;
exports["default"] = _default;